/**
 * Phrasing that asks for support itself — a ticket, a complaint, someone to talk to — or
 * reports something broken. Only answers to these get the "Create a support ticket" action.
 *
 * This module used to also pick the backend board for each message (`routeAssistantQuery`).
 * That router is retired: the backend routes every turn itself from the full conversation
 * history and ignores any board the client names, and a client-side regex in front of it only
 * ever lost — a typo or an unlisted follow-up phrasing sent the turn to the wrong board with
 * the other board's history stripped out. What is left here is a UI affordance, not routing.
 */
const SUPPORT_REQUEST_PATTERN =
  /\b(support|help\s?desk|tickets?|complaints?|complain|contact\s+(us|you|someone|the\s+team)|customer\s+(service|care)|(talk|speak|chat)\s+(to|with)\s+(a\s+|an\s+|the\s+)?(human|person|agent|someone|team)|escalat\w*|report\s+(a\s+|an\s+)?(bug|issue|problem|fault)|not\s+working|error|bug|issue|problem|broken|crash\w*|masl[ae]h?|masail|shikayat|shikait|kaam\s+nahi?n?\s+(kar|ho)\w*|nahi?n?\s+chal\w*|kharab)\b/i

/** True when the user is asking for support, not just how to use the portal. */
export function isSupportRequest(text: string): boolean {
  return SUPPORT_REQUEST_PATTERN.test(text.trim())
}

/**
 * True when a bot answer talks about support or trouble (support tickets, an error, a
 * problem, …). This is what decides the "Create a support ticket" action: it follows the
 * RESPONSE, not the question, so an answer that points the user at support — including a
 * "could not find anything … support tickets" reply — always offers the handoff.
 */
export function isSupportRelatedResponse(text: string): boolean {
  return SUPPORT_REQUEST_PATTERN.test(String(text ?? '').trim())
}
